import { useUserStore } from 'jsx/stores/userStore';
import COOKIE_KEYS from 'jsx/constants/cookieKeys';
import { OfferCategory, OFFER_CATEGORIES } from 'jsx/api/generated';

import cookie from '../cookie';

export const useOfferCategory = (): number => {
  const {
    userStore: { patient },
  } = useUserStore();

  const freeTrialOfferCategoryIds: Array<OfferCategory> = [
    OFFER_CATEGORIES.freeTrial,
    OFFER_CATEGORIES.agencyHigherPriceFreeTrial,
  ];

  // only want to rely on cookie on auth routes before we have a user
  if (Object.keys(patient).length === 0 && cookie.has(COOKIE_KEYS.offer)) {
    return Number(cookie.get(COOKIE_KEYS.offer));
  }

  if (
    !patient.introOffer ||
    freeTrialOfferCategoryIds.includes(patient.introOffer.offerCategory.id)
  ) {
    return OFFER_CATEGORIES.freeTrial;
  }

  return patient.introOffer.offerCategory.id;
};
